import { Observable } from "rxjs";
import { map, retry } from "rxjs/operators";
import { BaseApi, RequireAuthApi } from "@/api/base.api";
import { axiosInstance } from "@/api/axios.config.api";
import { CertificateModel } from "@/models/certificate.model";

export class CertificateApi extends BaseApi<CertificateModel> {
  constructor() {
    super("me/certificates", [RequireAuthApi.ALL]);
  }

  findByVerifyCode(code: string): Observable<CertificateModel> {
    return axiosInstance().get<CertificateModel>(`certificate/${code}`).pipe(
      retry(1),
      map(response => response.data)
    );
  }
}
